import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const MAINTENANCE_URL = `${backendUrl}/api/demandemaintenance/`;

class MaintenanceService {
	async getAllMaintenances() {
		try {
			const response = await axios.get(MAINTENANCE_URL);
			return response.data;
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	getMaintenance(id) {
		return axios.get(`${MAINTENANCE_URL}${id}/`);
	}

	createMaintenance(data) {
		return axios.post(MAINTENANCE_URL, data).catch((error) => {
			console.error('Erreur lors de la création du parent', error);
			throw error;
		});
	}

	updateMaintenance(id, data) {
		return axios.put(`${MAINTENANCE_URL}${id}/`, data);
	}

	deleteMaintenance(id) {
		return axios.delete(`${MAINTENANCE_URL}${id}/`);
	}

	getMaintenanceOptions() {
		return this.getAllMaintenances().then((Maintenances) => {
			const options = Maintenances.map((Maintenance) => ({
				value: Maintenance.id,
				label: (Maintenance.type_service + ' ').toUpperCase()
			}));
			return options;
		});
	}
}

export default new MaintenanceService();
